module.exports = __webpack_public_path__ + "img/164-portret-iisusa-v-ramke.jpg";